import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_4i1b948', 'template_2atnhed', form.current, {
        publicKey: 'FAWtQKURUxEppiNji',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
      e.target.reset()
  };
    return(
        <>
        <styledContactFrom>
        <section class="contact" id="contect">
    <h2 className="heading"> Contact <span>Me</span> </h2>
    <form action="" id="contactform" ref={form} onSubmit={sendEmail} >
        <div className="input-box">
        <input type="text" id="text" name="user_name" placeholder="name" required />
        <input type="email" id="email" name="user_email" placeholder="email" required />
        <input type="number" id="number" name="user_number" placeholder="number" required />
        <input type="text" id="subject" name="user_subject" placeholder="subject" required />
        </div>
         <textarea name="message" id="mascontact" cols="30" rows="10" placeholder="Your Message" ></textarea>
        <button type="submit" value="Send" className="btn">Send Massege</button>
    </form>


</section>
</styledContactFrom>
        
        
        </>
    );
};
